import { useMemo } from 'react';
import PhoneIcon from '@mui/icons-material/Phone';
import {
  FormItem,
  Input,
  Form,
  Container,
  SubmitButton,
  Loading,
  AutoComplete,
  Toggle,
  Datepicker,
} from '../../../components';
import { useGoogleConnect } from './useGoogleConnect';
import { PermissionCheck } from '../../../components';
import type { ConnectFormProps } from './types';

export const GoogleConnect = () => {
  const { onChange, form, handleCall, isCalling, presentations } =
    useGoogleConnect();

  const isDisabled = useMemo(() => {
    if (!form?.agent_id && !form?.override_url) return true;
    return !form?.meet_link || isCalling;
  }, [form, isCalling]);

  return (
    <>
      {isCalling ? (
        <Loading />
      ) : (
        <div className="flex items-center justify-center min-h-[80vh] px-4">
          <Container className="w-full sm:max-w-lg md:max-w-xl lg:max-w-2xl xl:max-w-3xl">
            <Form onChange={onChange} initialValue={form as ConnectFormProps}>
              <div className="flex flex-col gap-y-4">
                <FormItem<ConnectFormProps>
                  required
                  name="meet_link"
                  label="Conference Call URL"
                  className="w-full"
                  inline={false}
                >
                  <Input placeholder="Google Meet, Zoom, Teams, WebEx" />
                </FormItem>
                <FormItem<ConnectFormProps>
                  name="agent_id"
                  label="Agent ID"
                  className="w-full"
                  inline={false}
                >
                  <Input placeholder="Agent ID" />
                </FormItem>
                <FormItem<ConnectFormProps>
                  name="presentation_id"
                  label="Presentation"
                  className="w-full"
                  inline={false}
                >
                  <AutoComplete
                    options={presentations || []}
                    placeholder="Select Presentation"
                  />
                </FormItem>

                <FormItem<ConnectFormProps>
                  inline={false}
                  className="w-full"
                  name="join_at"
                  label="Schedule Time -  (leave empty if NOW)"
                >
                  <Datepicker minDate={new Date()} />
                </FormItem>

                <FormItem<ConnectFormProps>
                  name="bot_name"
                  label="Agent Name"
                  className="w-full"
                  inline={false}
                >
                  <Input placeholder="Agent Name" disabled={isDisabled} />
                </FormItem>
                <FormItem<ConnectFormProps>
                  name="bg_info"
                  label="Conference Call Background Info"
                  className="w-full"
                  inline={false}
                  tooltip="Make sure to use {ConferenceCallInfo} variable in Agent's prompt so it's aware about this data"
                >
                  <Input
                    placeholder="Conference Call Background Info"
                    disabled={isDisabled}
                    multiline
                  />
                </FormItem>

                <FormItem<ConnectFormProps>
                  inline={false}
                  className="w-full"
                  name="use_video_avatar"
                  label="Enable Video Avatar Mode"
                >
                  <Toggle />
                </FormItem>

                <PermissionCheck action="super_admin">
                  <FormItem<ConnectFormProps>
                    inline={false}
                    className="w-full"
                    name="use_dev_agent"
                    label="Use Agent from DEV"
                  >
                    <Toggle />
                  </FormItem>
                  <FormItem<ConnectFormProps>
                    inline={false}
                    className="w-full"
                    name="use_dev_url"
                    label="Use Widget from DEV"
                  >
                    <Toggle />
                  </FormItem>
                  <FormItem<ConnectFormProps>
                    inline={false}
                    className="w-full"
                    name="knowledgeBaseId"
                    label="Knowledge Base Id"
                  >
                    <Input placeholder="Knowledge Base Id" />
                  </FormItem>
                  <FormItem<ConnectFormProps>
                    inline={false}
                    name="bg_info_id"
                    label="Bg Info Id"
                    className="w-full"
                  >
                    <Input placeholder="Bg Info Id" />
                  </FormItem>
                  <FormItem<ConnectFormProps>
                    name="override_url"
                    label="Override URL"
                    className="w-full"
                    inline={false}
                  >
                    <Input placeholder="Override URL" />
                  </FormItem>
                </PermissionCheck>

                <div className="flex justify-end w-full">
                  <SubmitButton
                    label="Call"
                    icon={<PhoneIcon />}
                    size="medium"
                    type="primary"
                    onClick={handleCall}
                  />
                </div>
              </div>
            </Form>
          </Container>
        </div>
      )}
    </>
  );
};
